<template>
  <div class="row align-items-center">
    <div class="col-sm-12 col-md-6" v-for="(question, index) in questions" :key="index">
      <input style="display: none;" name="questions[]" :value="JSON.stringify(question)">
      <div class="card mt-4">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-header-title mb-0">
              Question {{ question.step }}
            </h5>
            <button type="button" class="btn btn-outline-danger" v-if="question.step > 2" @click="removeQuestion(question.step)">Supprimer</button>
        </div>
        <div class="card-body">
          <div class="form-group">
            <label :for="`question-${index}`">Question *</label>
            <input :id="`question-${index}`" type="text" name="question" class="form-control" v-model="question.name">
          </div>
          <AnswerComponent :question="question"></AnswerComponent>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-6">
      <button type="button" @click.prevent="addQuestion()" class="btn btn-outline-primary btn-block mt-4">Ajouter une question</button>
    </div>
  </div>
</template>

<script>
import AnswerComponent from './AnswerComponent.vue'

const defaultQuestion = (step) => {
  return {
    name: '',
    proposal_type: 'simple_choice',
    proposals: [],
    step: step,
  }
}

export default {
  props: {
    dataQuestions: Array,
  },

  components: {
    AnswerComponent
  },

  data() {
    return {
      questions: [
        Object.assign({}, defaultQuestion(1)),
        Object.assign({}, defaultQuestion(2)),
      ],
    }
  },

  methods: {
    removeQuestion(step) {
      const questionIndex = this.questions.findIndex((q) => q.step === step)

      if (questionIndex >= 0) {
        this.questions.splice(questionIndex, 1)

        const nextQuestionIndex = this.questions.findIndex((q) => q.step === step + 1)

        if (nextQuestionIndex >= 0) {
          for(let i = nextQuestionIndex; i <= this.questions.length; i++) {
            this.questions[i].step--
          }
        }
      }
    },

    addQuestion() {
      this.questions.push(Object.assign({}, defaultQuestion(this.questions.length + 1)))
    },
  },

  mounted() {
    if (this.dataQuestions) {
      this.questions = this.dataQuestions
    }
  }
}
</script>
